import { updateHTMLColour } from "./main";
import { currentPalette, findPalette, setPalette, strawberry } from "./palettes";
import { menu } from "./screens/default";
import { app, background, mainContainer, resetBackground, resetMenuGraphics, resizeCanvas, updateWidths, viewportInstances } from "./app";
import { ViewportInstance } from "./classes/ViewportInstance";


type Page = {
    title: string;
    pageID: number;
    headings: Heading[];
    profiles: Profile[];
    selectedProfile: number;
};

type Profile = {
    profileID: number;
    title: string;
}

type Heading = {
    title: string,
    settings: Setting[]
}

export type Setting = (SettingToggle | SettingSelect | SettingRange) & {
    subtitle?: string | undefined
} ;


type Requirement = {
    requiredID: number;
    accepted: number[];
}

type Option = {
    id: number;
    title: string;
    value?: number | undefined;
}

// export type presetID = 0 | 1 | 2 | 3;

type SettingToggle = {
    settingID: number;
    type: 'toggle';
    title: string;
    value: Map<number, number>
    requirements?: Requirement[] | undefined;
    sub?: boolean | undefined;
    lockedProfiles?: number[] | undefined;
}

type SettingSelect = {
    settingID: number;
    type: 'select';
    title: string;
    value: Map<number, number>
    options: Option[];
    requirements?: Requirement[] | undefined;
    sub?: boolean | undefined;
    lockedProfiles?: number[] | undefined;
}

type SettingRange = {
    settingID: number;
    type: 'range';
    title: string;
    value: Map<number, number>
    upper: number;
    lower: number;
    requirements?: Requirement[] | undefined;
    sub?: boolean | undefined;
    lockedProfiles?: number[] | undefined;
}

type SettingArray = {
    settingID: number;
    type: 'array';
    title: string;
    value: Map<number, number>[];
    requirements?: Requirement[] | undefined;
    sub?: boolean | undefined;
    lockedProfiles?: number[] | undefined;
}

type SettingData = {id: number; value: [number, number][];};

type ProfileData = {page: number, profileID: number}



export async function saveSettings(settingToSet?: Setting | undefined) {

    let parsedData: SettingData[] = [];
    const storedData = localStorage.getItem("appSettings");
    if (storedData) {
        parsedData = JSON.parse(storedData); 
    }

  const data = structuredClone(parsedData);;
  const profileData: ProfileData[] =  []; 

    // console.log(settings)

    //headings
    settings.forEach(page => {

        const profile = page.selectedProfile;
        profileData.push({page: page.pageID, profileID: profile}) //save profile selection

    
        page.headings.forEach(heading => {
            //settings
            heading.settings.forEach(setting => {

                if (settingToSet && setting.settingID !== settingToSet.settingID) {
                    return; //skip irrelevant settings
                }
                
                console.log(setting)
                // const customValue = setting.value || 0;  //set value for current profile
                const customValue = Array.from(setting.value.entries()) ?? 0; //converts map to array to allow json conversion

                const foundEntry = data.find(entry => entry.id === setting.settingID);
                if (foundEntry) {
                    foundEntry.value = customValue;
                } else {
                    data.push({ id: setting.settingID, value: customValue}) //pass value for given profile, locked values disabled by html & main.ts
                }
                

                switch (setting.settingID){
                    case 1:
                    case 37:
                    case 35:
                        setPalette();
                        //trigger transition
                        // menu?.updateColour(); redundant
                        // updateHTMLColour(false);
                        // for (const instance of viewportInstances) {
                        //     // instance.updateTextColour(true);
                            
                        // }
                        break;
                    case 30:
                        const value30 = settingValue(setting);
                        const html = document.getElementById('menu');
                        if (!html) break;
                        html.classList.toggle("html-effects", value30 === 1);
                        break;
                    case 31:
                        const value31 = settingValue(setting);
                        app.ticker.maxFPS = value31 ?? 60;
                        break;
                    case 44:
                    case 45:
                        updateWidths();
                        resizeCanvas();
                        break;
                    case 46:
                        resetMenuGraphics();
                        break;
                    case 2:
                        background.resetBits();
                        break;
                }
                for (const instance of viewportInstances) {
                    instance.updateSettings();
                }
            })
        })
    })

    menu.updateSettings();
    background.updateSettings();

// let parsedData: SettingData[] = [];
// const storedData = localStorage.getItem("appSettings");
// if (storedData) {
//     parsedData = JSON.parse(storedData); 
// }

// let finalData: SettingData[];
// if (parsedData.length !== 0) {
//     finalData = {
//         ...data,
//     }
// }

  console.log("saved")
  localStorage.setItem("appSettings", JSON.stringify(data));  //save custom values only
  localStorage.setItem("profileSettings", JSON.stringify(profileData)); //save profile setting
}

export async function loadSettings() {
    const storedProfiles = localStorage.getItem("profileSettings");
  const storedData = localStorage.getItem("appSettings"); //load custom values
  if (!storedData || !storedProfiles) {
    // updateHTMLColour(false);
    return;
  }

  let profileData : ProfileData[] = [];
  try {
    profileData = JSON.parse(storedProfiles)
  } catch (error) {
    console.error(error)
  }
  if (!profileData || profileData.length === 0) return;

  let data : SettingData[] = [];
  try {
     data = JSON.parse(storedData); 
  } catch (error) {
    console.error(error)
  }
  if (!data || data.length === 0) return;

  console.log(data)



    // const sorted = data.filter(unsorted => 
    //     unsorted.page === profile.profileID
    // )
    //unnecessary... have to load all profiles anyway, just go through all data and ensure entire map is uploaded

    //set profile selection
    settings.forEach(page => {
        page.selectedProfile = profileData.find(prof => prof.page === page.pageID)?.profileID ?? 0;
    })

    try {
        data.forEach(saved => {
            settings.forEach(page => {
            page.headings.forEach(heading => {
                heading.settings.forEach(setting => {
                    
                    if (setting.settingID === saved.id) {
                        setting.value = new Map(saved.value) ;
                    }
                });
            });
            });
        });
    } catch (error) {
        console.error("Data loaded incorrectly... Oops! "+error)
        // updateHTMLColour(false);
        return;
    }

    // setPalette(settingValue(findSettingByID(1)) ?? 0)
    // updateHTMLColour(false);

    
  console.log(settings)
}

/**
 * Search function for setting data
 * @param id - settingID to find
 * @returns 
 */
export function findSettingByID(id: number): Setting | undefined {


    for (const page of settings) {
        for (const heading of page.headings) {
            for (const setting of heading.settings) {
                
                if (setting.settingID === id) return setting;
            }
        }
    }
  
}

/**
 * Returns setting's current value for selected profile.
 * @param setting 
 * @returns 
 */
export function settingValue(setting: Setting | undefined) {
    
    if (typeof setting === undefined) return undefined;
    if (setting?.settingID === undefined) return undefined;

    

    const profile = pageInfo(setting)?.selectedProfile ?? 0;

    const map = setting.value;
    
    // const profileValue = map.has(profile) ? map.get(profile) : map.get(0) ?? undefined;

    // if (profileValue && setting.type === "select" && setting.options[profileValue].value) {
    //     return setting.options[profileValue].value;
    // } else {
    //     return profileValue
    // }

    return map.has(profile) ? map.get(profile) : map.get(0) ?? undefined;
}

export function pageInfo(setting: Setting) {
    
    return settings.find(page =>
        page.headings.find(heading => 
            heading.settings.find( s => 
                s.settingID === setting.settingID
            )
        )
    );

    // return settings.find(s => s.pageID === page)

}

//ALL SETTINGS

export const settings: Page[] = [
    //GRAPHICS
    {
        title: "Performance",
        pageID: 0,
        profiles: [
            //0 for default - should be inaccessible
            {
                profileID: 0,
                title: "Default",
            },
            {
                profileID: 1,
                title: "Low",
            },
            {
                profileID: 2,
                title: "High",
            },
            {
                profileID: 3,
                title: "Mobile",
            },
            {
                profileID: 4,
                title: "Custom",
            },
        ],
        selectedProfile: 4,
        headings: [
            // {
            //     title: 'Presets',
            //     settings: [{
            //         settingID: 0,
            //         type: 'select',
            //         title: "Preset",
            //         value: new Map([
            //             [0,0]
            //         ]),
            //         options: [
            //             {id: 0, title: "Custom"},
            //             {id: 1, title: "Low"},
            //             {id: 2, title: "High"},
            //             {id: 3, title: "Mobile"},
            //         ]
            //     }]
            // },
            {
                title: "Resolution",
                settings: [
                    {
                        settingID: 44,
                        type: 'select',
                        title: "Landscape Width",
                        options: [
                            {id: 620, title: "620px" },
                            {id: 680, title: "680px"},
                            {id: 720, title: "720px" }
                        ],
                        value: new Map([
                            [0, 680]
                        ])
                    },
                    {
                        settingID: 45,
                        type: 'select',
                        title: "Portrait Width",
                        options: [
                            {id: 380, title: "380px" },
                            {id: 480, title: "400px"},
                            {id: 420, title: "420px"}
                        ],
                        value: new Map([
                            [0, 420]
                        ])
                    }
                ]
            },
            {
                title: 'Theme',
                settings: [
                    {
                        settingID: 1,
                        type: 'select',
                        title: "Theme",
                        value: new Map([
                            [0,0]
                        ]),
                        options: [
                            { id: 0, title: "Strawberry"},
                            { id: 1, title: "Blueberry"},
                            { id: 2, title: "Raspberry"},
                            {id: 8, title: "Blackberry"},
                            {id: 9, title: "Summer Fruits"},
                            { id: 3, title: "Marmalade"},
                            { id: 4, title: "Lemon Curd"},
                            { id: 6, title: "Lime Jelly"},
                            { id: 7, title: "Blood Orange"},
                            { id: 5, title: "Mango Pickle"},
                            { id: 10, title: "Baked Beans"}
                        ]
                    },
                    {
                        settingID: 39,
                        type: 'toggle',
                        title: "Background",
                        value: new Map([
                            [0,1],
                        ])
                    },
                    {
                        settingID: 2,
                        type: 'select',
                        title: "Consistency",
                        value: new Map([
                            [0,0],
                            [1,2] //low, - no details
                        ]),
                        options: [
                            { id: 0, title: "Regular" },
                            { id: 1, title: "Extra Bits" },
                            { id: 2, title: "Seedless" }
                        ],
                        lockedProfiles: [1]
                    },
                    {
                        settingID: 35,
                        type: 'toggle',
                        title: "Real Fruit Pieces",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 2,
                                accepted: [0,1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 37,
                        type: 'range',
                        title: "Hygiene",
                        value: new Map([
                            [0,100]
                        ]),
                        upper: 100,
                        lower: 0
                    }
                ]
            },
            {
                title: "Performance",
                settings: [
                    {
                        settingID: 11,
                        type: 'toggle',
                        title: "Detail Rotation",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 2,
                                accepted: [0,1]
                            }
                        ]
                    },
                    {
                        settingID: 29,
                        type: 'toggle',
                        title: "Relative Detail Positioning",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 2,
                                accepted: [0,1]
                            }
                        ],
                        subtitle: "Required for more extreme waves"
                    },
                    {
                        settingID: 31,
                        type: 'range',
                        title: "Refresh Limit",
                        value: new Map([
                            [0,100]
                        ]),
                        lower: 30,
                        upper: 100,
                        subtitle: "Can lower GPU usage, but causes stuttering"
                    },
                    {
                        settingID: 34,
                        type: 'range',
                        title: "Background FPS",
                        value: new Map([
                            [0,63],
                        ]),
                        lower: 30,
                        upper: 100,
                        subtitle: "Lower CPU usage"
                    },
                    {
                        settingID: 28,
                        type: 'range',
                        title: "Wave Render Scale",
                        value: new Map([
                            [0,25],
                            [1,40]
                        ]),
                        lower: 5,
                        upper: 50,
                        lockedProfiles: [1],
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        subtitle: "Lower is smoother, but less stable"
                    },
                    {
                        settingID: 30,
                        type: 'toggle',
                        title: "Menu Shadows",
                        value: new Map([
                            [0,1],
                            [1,0]
                        ]),
                        lockedProfiles: [1]
                    },
                    {
                        settingID: 36,
                        type: 'toggle',
                        title: "Live View",
                        value: new Map([
                            [0,0],
                            [1,0]
                        ]),
                        lockedProfiles: [1],
                        subtitle: "Increased processing during menu activation"
                    },
                    {
                        settingID: 43,
                        type: 'select',
                        title: "Viewing Mode",
                        options: [
                            {id: 0, title: "10% Alpha"},
                            {id: 4, title: "25% Alpha"},
                            {id: 1, title: "50% Alpha"},
                            {id: 2, title: "0% Alpha"}
                        ],
                        value: new Map([
                            [0,0]
                        ]),
                        requirements: [
                            {
                                requiredID: 36,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 47,
                        type: 'select',
                        title: "Colour Transitions",
                        options: [
                            {id: 0, title: "Standard"},
                            {id: 1, title: "Skip Half"},
                            {id: 2, title: "Instant"}
                        ],
                        value: new Map([
                            [0,0],
                            [3,2]
                        ])
                    }
                ]
            },
            {
                title: 'Background',
                settings: [
                    
                    
                    {
                        settingID: 3,
                        type: 'range',
                        title: "Waves",
                        value: new Map([
                            [0,12],
                            [1,6]
                        ]),
                        upper: 20,
                        lower: 5,
                        lockedProfiles: [1],
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        subtitle: "Higher settings become very intensive"
                    },
                    {
                        settingID: 5,
                        type: 'range',
                        title: "Opacity",
                        //divided by 10
                        value: new Map([
                            [0,6]
                        ]),
                        upper: 10,
                        lower: 4,
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        subtitle: "Transparency can become unstable on Mobile"
                    },
                    
                    {
                        settingID: 22,
                        type: 'range',
                        title: "Wavelength",
                        value: new Map([
                            [0,50]
                        ]), //divide by 10
                        upper: 100,
                        lower: 10,
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 23,
                        type: 'range',
                        title: "Amplitude",
                        value: new Map([
                            [0,65]
                        ]), //divide by 10
                        upper: 100,
                        lower: 10,
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 24,
                        type: 'range',
                        title: "Vertical Speed",
                        value: new Map([
                            [0,30]
                        ]), //divide by 10
                        upper: 100,
                        lower: 0,
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 25,
                        type: 'range',
                        title: "Horizontal Offset",
                        value: new Map([
                            [0,50]
                        ]), //divide by 10
                        upper: 100,
                        lower: 0,
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 26,
                        type: 'range',
                        title: "Change Rate",
                        value: new Map([
                            [0,50]
                        ]), //divide by 10
                        upper: 100,
                        lower: 0,
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 12,
                        type: 'toggle',
                        title: "Wave Bob",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 13,
                        type: 'range',
                        title: "Bob Amount",
                        value: new Map([
                            [0,50]
                        ]),
                        upper: 100,
                        lower: 50,
                         requirements: [
                            {
                                requiredID: 12,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 14,
                        type: 'range',
                        title: "Bob Speed",
                        value: new Map([
                            [0,50]
                        ]),
                        upper: 100,
                        lower: 1,
                         requirements: [
                            {
                                requiredID: 12,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 9,
                        type: 'toggle',
                        title: "Wave Sway",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 10,
                        type: 'range',
                        title: "Sway Amount",
                        value: new Map([
                            [0,4]
                        ]),
                        upper: 10,
                        lower: 1,
                         requirements: [
                            {
                                requiredID: 9,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 6,
                        type: 'toggle',
                        title: "Wobble",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 7,
                        type: 'range',
                        title: "Wobble Amount",
                        value: new Map([
                            [0,13]
                        ]), //divide by 100
                        upper: 50,
                        lower: 10,
                        requirements: [
                            {
                                requiredID: 6,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 8,
                        type: 'range',
                        title: "Wobble Wavelength",
                        value: new Map([
                            [0,50]
                        ]), //divide by 10
                        upper: 250,
                        lower: 10,
                        requirements: [
                            {
                                requiredID: 6,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 27,
                        type: 'range',
                        title: "Wobble Speed",
                        value: new Map([
                            [0,50]
                        ]), //divide by 10
                        upper: 250,
                        lower: 0,
                        requirements: [
                            {
                                requiredID: 6,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 4,
                        type: 'toggle',
                        title: "Extra Funk",
                        value: new Map([
                            [0,0],
                            [1,0]
                        ]),
                        lockedProfiles: [1],
                        requirements: [
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ]
                    },
                    {
                        settingID: 21,
                        type: 'range',
                        title: "Extra Multiplier",
                        value: new Map([
                            [0,50]
                        ]), //divide by 10
                        upper: 100,
                        lower: 10,
                        requirements: [
                            {
                                requiredID: 4,
                                accepted: [1]
                            },
                            {
                                requiredID: 39,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                ]
            },
            {
                title: "Text",
                settings: [
                    {
                        settingID: 15,
                        type: 'toggle',
                        title: "Depth Shading",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    
                    {
                        settingID: 16,
                        type: 'toggle',
                        title: "Drop Shadows",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    {
                        settingID: 17,
                        type: 'toggle',
                        title: "Hard Directional Lighting",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    {
                        settingID: 19,
                        type: 'range',
                        title: "Cast Distance",
                        value: new Map([
                            [0,20]
                        ]),
                        lower: 1,
                        upper: 100,
                        requirements: [
                            {
                                requiredID: 17,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                    {
                        settingID: 18,
                        type: 'toggle',
                        title: "Soft Directional Lighting",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    {
                        settingID: 20,
                        type: 'toggle',
                        title: "Mouse Glow",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    {
                        settingID: 32,
                        type: 'toggle',
                        title: "Click Impression",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    {
                        settingID: 33,
                        type: 'toggle',
                        title: "Letter Animations",
                        value: new Map([
                            [0,1]
                        ]),
                    },
                    {
                        settingID: 38,
                        type: 'toggle',
                        title: "Gradient",
                        value: new Map([
                            [0,1]
                        ])
                    }

                ]
            },
            {
                title: "Menu",
                settings:[
                    {
                        settingID: 46,
                        type: 'toggle',
                        title: "HTML Menus",
                        value: new Map([
                            [0,1]
                        ])
                    },
                    {
                        settingID: 40,
                        type: 'toggle',
                        title: "Gradient Fill",
                        value: new Map([
                            [0,1]
                        ])
                    },
                    {
                        settingID: 41,
                        type: 'toggle',
                        title: "Wave Animation",
                        value: new Map([
                            [0,1]
                        ])
                    },
                    {
                        settingID: 42,
                        type: 'toggle',
                        title: "Extra Jam Layers",
                        value: new Map([
                            [0,1]
                        ]),
                        requirements: [
                            {
                                requiredID: 41,
                                accepted: [1]
                            }
                        ],
                        sub: true
                    },
                ]
            }
        ]
    },
    {
        pageID: 13,
        title: "Visual Control",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 14,
        title: "Text & Menus",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 4,
        title: "Test: Error",
        headings: [
            
        ],
        profiles: [

        ],
        selectedProfile: 0
    },
    {
        pageID: 1,
        title: "Help",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 5,
        title: "About",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 2,
        title: "Account",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 6,
        title: "Submissions",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 7,
        title: "World Entries",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 8,
        title: "Mail",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 3,
        title: "Jam Presets",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 9,
        title: "Achievements",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 10,
        title: "Palettes",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 11,
        title: "Labels",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
    {
        pageID: 12,
        title: "History",
        headings: [

        ],
        profiles: [

        ],
        selectedProfile: 1
    },
]